/* eslint-disable no-throw-literal */
import {
  GET_STEPUP_EXIST,
  GET_STEPUP_CALL_EXIST,
  STEPUP_NOANSWER_LIST,
  STEPUP_ANSWER_DETAIL_LIST,
  STEPUP_ANSWER_UPDATE,
  STEPUP_ALL_ANSWER_UPDATE,
  GET_QUESTIONS
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_STEPUP_EXIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/step_up_answers/exist', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_STEPUP_CALL_EXIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/step_up_answers/call_exist', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STEPUP_NOANSWER_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/step_up_answers/noanswer_list', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STEPUP_ANSWER_DETAIL_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/step_up_answers/answer_detail_list', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STEPUP_ANSWER_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/step_up_answers/save_answers', id: params.id, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [STEPUP_ALL_ANSWER_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/step_up_answers/save_answer_flag', data: {id: params.id} })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_QUESTIONS] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/questions/get_question_check_list', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/stepup.js